// extracted by mini-css-extract-plugin
export default {"formRow":"LicensesTab_formRow__ft-Ku","buttonContainer":"LicensesTab_buttonContainer__HxkDC"};